export default __webpack_public_path__ + "static/media/arm_swing_b.16f3b26f.png";